export default __webpack_public_path__ + "static/media/form-name.59bbc052.svg";